
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number] as PropType<string | number>,
            default: null
        },
        color: {
            type: String as PropType<'royal-blue' | 'orange' | 'green' | 'red'>,
            default: 'royal-blue'
        }
    }
})
